import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import './i18n';
import { GlobalProvider, appName, GlobalContext  } from 'context';
import { BrowserRouter } from 'react-router-dom';

import {
  UserDetails,
  Proxy,
  getDecryptedValue,
} from 'common';
import { LoggingContextProvider } from '@sentara-health/platform-logging-monitoring';

const AZURE_INSIGHTS_INSTRUMENTATION_KEY = process.env.REACT_APP_INSTRUMENTATION_KEY;

const AppContent = ({ 
  header, 
  authToken, 
  xAuthToken, 
  xSentaraTokenID 
}: { 
  header: Record<string, string | undefined>; 
  authToken: string; 
  xAuthToken: string; 
  xSentaraTokenID: string;
}) => {
  const { getFeature } = React.useContext(GlobalContext);
  
  if (getFeature?.AzureAppInsights && AZURE_INSIGHTS_INSTRUMENTATION_KEY) {
    return (
      <LoggingContextProvider azureInsightsInstrumentationKey={AZURE_INSIGHTS_INSTRUMENTATION_KEY}>
        <App header={header} authToken={authToken} xAuthToken={xAuthToken} xSentaraTokenID={xSentaraTokenID}/>
      </LoggingContextProvider>
    );
  }
  
  return <App header={header} authToken={authToken} xAuthToken={xAuthToken} xSentaraTokenID={xSentaraTokenID}/>;
};

const startApplication = async () => {
  if (process.env.NODE_ENV === 'production') {
    console.warn = function () {};
    console.error = function () {};
    console.log = function () {};
  }

  const root = ReactDOM.createRoot(
    document.getElementById('root') as HTMLElement
  );
  const MemberId = (await getDecryptedValue(Proxy.MemberId)) || '';
  
  let header = {
    'Ocp-Apim-Subscription-Key': process.env.REACT_APP_SUBSCRIPTION_KEY,
    'DeviceInfo': `{"appName": "${appName}"}`
  };
  if (MemberId !== '') {
    let data = {
      Proxyfor: MemberId,
    };
    header = Object.assign(header, data);
  }
  const authToken = await getDecryptedValue(UserDetails.authToken);
  const personalDetails = await getDecryptedValue(UserDetails.guest);
  const personalInfo =JSON.parse(personalDetails || '{}');
  const xAuthToken = personalInfo?.xAuthToken || '';
  const xSentaraTokenID = personalInfo?.xSentaraTokenID || '';
  root.render(
    <React.StrictMode>
      <BrowserRouter>
        <GlobalProvider>
          <AppContent
            header={header} 
            authToken={authToken} 
            xAuthToken={xAuthToken} 
            xSentaraTokenID={xSentaraTokenID}
          />
        </GlobalProvider>
      </BrowserRouter>
    </React.StrictMode>
  );
};

startApplication();
